import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ILabReportStatusResponse } from "@/api_framework/api_modals/LabReport";
import { setStatusList } from "@/app_redux/reducers/slices/auth/lab_report_slice";

AxiosCurlirize(axios, () => {});
export const useLabReportStatusListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(async (type: number) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(LAB_REPORT?.STATUS_LIST?.baseURL ?? "", {
           params: {
              type
            },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ILabReportStatusResponse>) => {
          if (res.data.status === true) {
            dispatch(setStatusList({ data: res.data.data }));
          } else {
            dispatch(setStatusList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
